import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ChatMessageOpenAI } from '../../Models/Session';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { Router } from '@angular/router';
import { NavigationService } from '../../Services/navigation.service';
import { Capacitor } from '@capacitor/core';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';

@Component({
  selector: 'app-economic-chat',
  templateUrl: './economic-chat.component.html',
  styleUrls: ['./economic-chat.component.css'],
  standalone:false,
})
export class EconomicChatComponent extends BaseComponent implements OnInit{
  userForm!: FormGroup;
  loading:boolean=false;
  messageHistory:ChatMessageOpenAI[]=[]
  userRole:string=''
  chatHeight: string = '50vh';
  sidebarVisible: boolean = false;
  isMobile: boolean = false;
  constructor
  (
    private renderer: Renderer2,
     private messageService: MessageService,
     private formBuilder:FormBuilder,
     private api:BaseApiService,
     private auth:AuthService,
     private Router:Router,
     private navigationService: NavigationService,
  )
  {
    super();
     this.userRole=this.auth.getRoles().toString();
  }





  onSubmit() {
    if (this.userForm.valid) {
      this.loading   =true;
      const formData = this.userForm.value;
      this.api.create("AdminLogs/Messages",formData)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        {
          next: (response: ChatMessageOpenAI[]) => {
            this.loading = false;
  
            // Append new messages to the chat history
            this.messageHistory.push(...response);
            this.userForm.reset();
            this.initilizaform();
          },
          error:( error) => {
            this.loading=false
          }
        }
        
      );
    } else {
      this.userForm.markAllAsTouched();
    }
  }


  initilizaform(){
    this.userForm = this.formBuilder.group
    (
      {
         prompt : ['', [Validators.required]]
      }
    );
  }

  ngAfterViewInit() {
    setTimeout(() => this.updateChatHeight(), 0); // Delay to ensure DOM is ready
  }

  @HostListener('window:resize')
  onResize() {
    this.updateChatHeight();
  }

  private updateChatHeight() {
    const bottomNav = document.querySelector('.bottom-navigation') as HTMLElement;
    
    if (!bottomNav) {
      return;
    }

    let bottomNavHeight = bottomNav.offsetHeight || 60; 
    bottomNavHeight     = bottomNavHeight-450;
    this.chatHeight = `${window.innerHeight + bottomNavHeight}px`;

  }

  ngOnInit() {
    this.updateChatHeight();
    this.initilizaform();
    this.isMobile = Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios';
        
    if (this.isMobile) {
      this.renderer.addClass(document.body, 'mobile-platform');
    }
  }


  logut(){
    this.auth.logout();
    this.Router.navigate(['/login'])
  }
  showSidebar: boolean = true;
  showSide:boolean=false;
  ShowPannel(){
    this.sidebarVisible=true;
   }

  logOut(){
    this.auth.logout();
    this.Router.navigate(['/login']);
  }

  goBack(): void {
    this.navigationService.goBack();
  }

  isRouteActive(routes: string[]): boolean {
    const currentUrl = this.Router.url;
    if(routes.some(route => currentUrl.startsWith(route))){
      return true;
    }
    else{
      return routes.some(route => this.Router.isActive(route, true));
    }
  }

  getClassForRoute(route: string): string {
    const isActive = this.Router.isActive(route, true);

    if (isActive) {
      return 'nav-link u-sidebar-nav-menu__link active smooth-shadow-lg mb-1';
    } else {
      return 'nav-link u-sidebar-nav-menu__link mb-1';
    }
  }
}
